import { AxiosErrorHandler } from 'ui';
import { PublicEventSkeleton } from '../components';
import { useEventPublicQuery } from '../queries';
import { PublicProgramEventContent } from './public-program-event-content';

type P = {
  eventId: string;
};

const PublicProgramEvent = ({ eventId }: P) => {
  const {
    data: eventContentObject,
    error: eventError,
    isFetching: isFetchingEvent,
    isLoading: isLoadingEvent,
  } = useEventPublicQuery({ eventId }, { throwOnError: false });

  return (
    <AxiosErrorHandler error={eventError}>
      {isLoadingEvent || isFetchingEvent || !eventContentObject ? (
        <PublicEventSkeleton />
      ) : (
        <PublicProgramEventContent eventContentObject={eventContentObject} />
      )}
    </AxiosErrorHandler>
  );
};

export default PublicProgramEvent;
